<template>
  <div class="maintenance-repair">
    <div class="title-en">综合维保维修</div>
    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <el-button @click="openColumnsDialog">表头设置</el-button>
          <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
        </div>
        <el-table :data="tableData" border stripe @selection-change="handleSelectionChange" ref="table"
          v-loading="loading">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column v-for="(column, index) in visibleColumns" :key="index" :prop="column.prop"
            :label="column.label" :width="column.width">
            <template slot-scope="scope">
              <span v-if="
                column.prop === 'CreatedTime' ||
                column.prop === 'EndTime'
              ">{{
                scope.row[column.prop]
                  ? $moment(scope.row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                  : '-'
              }}</span>
              <span v-else>{{ scope.row[column.prop] || '-' }}</span>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog title="设置显示项" :visible.sync="showColumnsDialog" :append-to-body="true" width="400px"
          :close-on-click-modal="false" custom-class="columns-dialog" :modal-append-to-body="false"
          :destroy-on-close="true">
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop" class="checkbox-item">
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>

        <div class="pagination-container">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getMaintenancefixShow, getMaintenancefixShowAll } from '@/api/operation';
import { debounce } from 'lodash';
import * as XLSX from 'xlsx';

export default {
  name: 'MaintenanceRepair',
  data() {
    return {
      loading: false,
      tableData: [
        // {
        //   AppendReason: '',
        //   CampusName: '贵阳-贵安七星',
        //   ChangeId: '',
        //   CreatedTime: '2025-04-25 17:28:22',
        //   Creator: 'v_xiaychen',
        //   EndTime: '2025-05-19 14:27:58',
        //   EventId: '',
        //   FacilitiesProfessional: '弱电',
        //   FailureReason: '门磁松动',
        //   Id: 107,
        //   IsAppend: '否',
        //   MozuName: '贵阳贵安七星模组21',
        //   PoId: '',
        //   ProblemDesc: '门禁的门磁松动，需要厂家进行紧固',
        //   RepairBusiness: '鸿云',
        //   RepairEngineer: 'lujishi',
        //   RepairLevel: '普通',
        //   RepairScore: '100',
        //   RepairStatus: '维修完成',
        //   TaskName: '',
        //   TicketId: '20250425036752',
        //   TicketTitle: '贵阳贵安七星模组21-门磁脱落',
        //   UpstreamBusiness: '现场反馈',
        //   UpstreamId: '',
        // },
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showColumnsDialog: false,
      selectedColumns: [],
      exportLoading: false,
      debouncedExport: null,
      selectedRows: [],
      defaultSelectedColumns: [
        'Id',
        'TicketId',
        'TicketTitle',
        'RepairStatus',
        'CampusName',
        'MozuName',
        'RepairLevel',
        'CreatedTime',
        'Creator',
        'EndTime',
        'RepairEngineer',
        'RepairBusiness',
        'FacilitiesProfessional',
        'FailureReason',
        'ProblemDesc',
        'RepairScore',
        'UpstreamBusiness',
        'UpstreamId',
        'ChangeId',
        'PoId',
        'TaskName',
        'IsAppend',
        'AppendReason',
        'IsDealTimely',
        'OvertimeType',
        'OvertimeProofDesc',
        'QcResult',
        'IsResponseTimely',
        'IsOneTimeRepairPassed'
      ],
      columns: [
        { prop: 'Id', label: 'ID', width: '80' },
        { prop: 'TicketId', label: '维修单号', width: '150' },
        { prop: 'TicketTitle', label: '工单标题', width: '200' },
        { prop: 'RepairStatus', label: '工单状态', width: '120' },
        { prop: 'CampusName', label: '园区', width: '150' },
        { prop: 'MozuName', label: '模组', width: '180' },
        { prop: 'RepairLevel', label: '维修等级', width: '100' },
        { prop: 'CreatedTime', label: '创建时间', width: '150' },
        { prop: 'Creator', label: '创建人', width: '120' },
        { prop: 'EndTime', label: '结单时间', width: '150' },
        { prop: 'RepairEngineer', label: '维修工程师', width: '120' },
        { prop: 'RepairBusiness', label: '维修厂商', width: '120' },
        { prop: 'FacilitiesProfessional', label: '专业', width: '100' },
        { prop: 'FailureReason', label: '故障原因/维修原因', width: '150' },
        { prop: 'ProblemDesc', label: '故障现象描述', width: '200' },
        { prop: 'RepairScore', label: '维修评分', width: '100' },
        { prop: 'UpstreamBusiness', label: '维修来源', width: '120' },
        { prop: 'UpstreamId', label: '上游单号', width: '150' },
        { prop: 'ChangeId', label: '关联变更单号', width: '150' },
        { prop: 'PoId', label: '关联po单号', width: '150' },
        { prop: 'TaskName', label: '任务名称', width: '150' },
        { prop: 'IsAppend', label: '是否补单', width: '100' },
        { prop: 'AppendReason', label: '补单原因', width: '150' },
        { prop: 'IsDealTimely', label: '是否处理及时', width: '120' },
        { prop: 'OvertimeType', label: '超时举证分类', width: '120' },
        { prop: 'OvertimeProofDesc', label: '举证描述', width: '150' },
        { prop: 'QcResult', label: '合格/不合格', width: '100' },
        { prop: 'IsResponseTimely', label: '是否响应及时', width: '120' },
        { prop: 'IsOneTimeRepairPassed', label: '是否一次性维修通过', width: '150' },
      ],
      searchForm: {},
    };
  },
  computed: {
    visibleColumns() {
      return this.columns.filter((column) => this.selectedColumns.includes(column.prop));
    },
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
  created() {
    this.selectedColumns = [...this.defaultSelectedColumns];
    // this.fetchData({
    //   page: this.currentPage,
    //   size: this.pageSize
    // });
    this.debouncedExport = debounce(this.handleExport, 300);
  },

  methods: {
    async fetchData(params = {}) {
      // 添加结束时间的时分秒
      if (params.end_time) {
        params.end_time = this.$moment(params.end_time).format('YYYY-MM-DD 23:59:59');
      }

      // 合并分页参数
      const requestParams = {
        ...this.searchForm,
        page: this.currentPage,
        size: this.pageSize,
        export: "0",  // 添加export参数
        start_time: this.searchForm.start_time,  // 确保时间参数被包含
        end_time: this.searchForm.end_time,
        TicketId: this.searchForm.TicketId || null,
        CampusName: this.searchForm.CampusName || null,
        abnormal_situation: this.searchForm.abnormal_situation,  // 添加异常情况参数
        ...params
      };

      // 调试日志
      // console.log('fetchData参数:', requestParams);

      this.searchForm = { ...requestParams };

      this.loading = true;
      try {
        const response = await getMaintenancefixShow(requestParams);
        // console.log('API返回数据:', response); // 调试日志

        if (response.data.code == 200) {
          this.tableData = response.data.data.data || [];
          this.total = response.data.data.count || 0;
          console.log(`分页信息 - 当前页: ${this.currentPage}, 每页: ${this.pageSize}, 总数: ${this.total}`);
        }
      } catch (error) {
        console.error('请求错误:', error);
        let errorMessage = '获取数据失败';
        if (error.response && error.response.status === 422) {
          errorMessage = '请求参数格式不正确，请检查输入';
        }
        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        if (this.selectedRows.length === 0) {
          // 导出全部数据
          this.loading = true;
          const response = await getMaintenancefixShowAll({
            ...this.searchForm,
            start_time: this.searchForm.start_time,
            end_time: this.searchForm.end_time,
            abnormal_situation: this.searchForm.abnormal_situation,
          });

          if (response.data) {
            this.loading = false;
            const allData = response.data.data.data || [];
            const worksheetData = allData.map((row) => {
              const rowData = {};
              this.visibleColumns.forEach((column) => {
                if (column.prop !== 'operation') {
                  let value = row[column.prop];
                  if (
                    ['CreatedTime', 'EndTime'].includes(
                      column.prop
                    )
                  ) {
                    value = value ? this.$moment(value).format('YYYY-MM-DD HH:mm:ss') : '-';
                  }
                  rowData[column.label] = value || '-';
                }
              });
              return rowData;
            });

            const worksheet = XLSX.utils.json_to_sheet(worksheetData);

            const colWidths = {};
            this.visibleColumns.forEach((column, index) => {
              const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
              colWidths[XLSX.utils.encode_col(index)] = { wch: width };
            });
            worksheet['!cols'] = Object.values(colWidths);

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, '综合维保维修列表');

            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            const filename = `综合维保维修列表_${timestamp}.xlsx`;

            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          }
        } else {
          const worksheetData = this.selectedRows.map((row) => {
            const rowData = {};
            this.visibleColumns.forEach((column) => {
              if (column.prop !== 'operation') {
                let value = row[column.prop];
                if (
                  ['CreatedTime', 'EndTime'].includes(column.prop)
                ) {
                  value = value ? this.$moment(value).format('YYYY-MM-DD HH:mm:ss') : '-';
                }
                rowData[column.label] = value || '-';
              }
            });
            return rowData;
          });

          const worksheet = XLSX.utils.json_to_sheet(worksheetData);

          const colWidths = {};
          this.visibleColumns.forEach((column, index) => {
            const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
            colWidths[XLSX.utils.encode_col(index)] = { wch: width };
          });
          worksheet['!cols'] = Object.values(colWidths);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, '综合维保维修列表');

          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          const filename = `综合维保维修列表_${timestamp}.xlsx`;

          XLSX.writeFile(workbook, filename);
          this.$message.success('导出成功');
        }
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 改变每页条数后通常回到第一页
      this.fetchData(); // 确保调用时会使用最新的参数
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData(); // 确保调用时会使用最新的参数
    }, openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-tabs {
  margin-bottom: 20px;
}

.analysis-container {
  min-height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.placeholder {
  color: #909399;
  font-size: 16px;
}

.container {
  padding: 20px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 13px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.box-card {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}

.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button+.el-button {
  margin-left: 8px;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}

::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}

::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}

/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: 100% !important;
}

::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}

::v-deep .el-tabs__nav-wrap::after {
  height: 1px !important;
}
</style>